"use strict";

require("core-js/modules/es.array.reduce");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // Copyright 2017-2020 @polkadot/x-textencoder authors & contributors
// SPDX-License-Identifier: Apache-2.0
// This is very limited, only handling Ascii values

var TextDecoder = /*#__PURE__*/function () {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-useless-constructor
  function TextDecoder(_) {// nothing

    _classCallCheck(this, TextDecoder);
  }

  _createClass(TextDecoder, [{
    key: "decode",
    value: function decode(value) {
      return value.reduce(function (str, code) {
        return str + String.fromCharCode(code);
      }, '');
    }
  }]);

  return TextDecoder;
}();

exports.default = TextDecoder;